var i = /* @__PURE__ */ ((e) => (e.dark = "dark", e.light = "light", e.transparent = "transparent", e))(i || {}), c = /* @__PURE__ */ ((e) => (e.md = "md", e.lg = "lg", e))(c || {}), d = /* @__PURE__ */ ((e) => (e.asc = "asc", e.desc = "desc", e.none = "none", e))(d || {}), u = /* @__PURE__ */ ((e) => (e.all = "all", e.none = "none", e.partial = "partial", e))(u || {}), h = /* @__PURE__ */ ((e) => (e.left = "left", e.right = "right", e))(h || {});
const o = (e) => {
  switch (e) {
    case "md":
      return "table-row-md";
    case "lg":
      return "table-row-lg";
    default:
      return "table-row-lg";
  }
}, b = (e) => {
  switch (e) {
    case "dark":
      return "table-head-row-dark";
    case "light":
      return "table-head-row-light";
    case "transparent":
    default:
      return "";
  }
};
function f(e, t) {
  const a = ["table-container"];
  if (e && a.push("table-has-scroll"), t.headers && t.headers.find((l, n) => {
    var s;
    return ((s = l.prependedContent) == null ? void 0 : s.trim()) && n === 0;
  }) && !t.selectableRow && !t.expandableRow && a.push("table-prepended-first-column"), t.headers) {
    const l = t.headers.length - 1;
    t.headers.find((n, s) => {
      var r;
      return ((r = n.prependedContent) == null ? void 0 : r.trim()) && s === l;
    }) && a.push("table-prepended-last-column");
  }
  return t.containerCssClass && t.containerCssClass.trim() ? `${a.join(" ")} ${t.containerCssClass}` : a.join(" ");
}
function w(e, t) {
  const a = ["table"];
  return (e.selectableRow || e.expandableRow) && a.push("table-interactive"), e.columnBorder && !(e.selectableRow || e.expandableRow) && a.push("table-col-border"), e.expandableRow && a.push("table-expandable"), t && t.trim() ? `${a.join(" ")} ${t}` : a.join(" ");
}
function g(e) {
  const t = ["table-head-row"];
  return e.stickyHeader && t.push("table-head-row-sticky"), t.push(o(e.headRowSize)), t.push(b(e.variant)), t.join(" ");
}
function y(e) {
  const t = ["table-body-row-cell"];
  return e.loading && t.push("table-body-row-cell-loading"), e.action && t.push("table-row-action"), t.join(" ");
}
function C({ action: e }) {
  const t = ["table-head-row-cell"];
  return e && t.push("table-row-action"), t.join(" ");
}
function R({ sortable: e, alignment: t }) {
  const a = ["table-head-row-cell-content"];
  return e || a.push("table-head-row-cell-unsortable"), t === "right" && a.push("table-head-row-cell-right"), a.join(" ");
}
function j({ sortState: e }) {
  const t = ["table-head-row-cell-sort"];
  return e !== "none" && t.push("table-head-row-cell-sort-shown"), t.join(" ");
}
function T(e) {
  const t = ["table-head-resizer"];
  return e && t.push("table-head-resizing"), t.join(" ");
}
function m({ selectedRowIdsSetRef: e, bodySizeRef: t }, { isRowExpanded: a, rowId: l }) {
  const n = ["table-body-row"];
  return e.includes(l ?? "") && n.push("table-body-row-selected"), n.push(o(t)), n.join(" ");
}
const x = Symbol("TableBodyRowProps");
export {
  h as EHeadCellAlignment,
  u as SelectAllState,
  c as Size,
  d as SortState,
  x as TableBodyRowPropsSymbol,
  i as Variant,
  f as getTableContainerStyleClasses,
  g as getTableHeadStyleClasses,
  w as getTableStyleClasses,
  y as getTdStyleClasses,
  R as getThButtonStyleClasses,
  T as getThResizerStyleClasses,
  j as getThSortStyleClasses,
  C as getThStyleClasses,
  m as getTrStyleClasses
};
